import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class PeliculasService {

  constructor(private http: HttpClient) {}
  getPeliculas() {
    return this.http.get("assets/data/peliculas.json");
  }
}
